"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var browser_1 = require("@airbrake/browser");
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
var AirbrakeService = (function () {
    function AirbrakeService(options) {
        this.logPrefix = 'AirbrakeService';
        if ((0, isNil_1.default)(options)) {
            throw new Error("".concat(this.logPrefix, " missing options!"));
        }
        this.airbrakeClient = new browser_1.Notifier(options);
    }
    AirbrakeService.prototype.notify = function (_a) {
        var error = _a.error, params = _a.params, context = _a.context;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4, this.airbrakeClient.notify({
                                error: error,
                                params: params,
                                context: context
                            })];
                    case 1:
                        _b.sent();
                        return [3, 3];
                    case 2:
                        e_1 = _b.sent();
                        console.log("".concat(this.logPrefix, " failed notifying"), e_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    return AirbrakeService;
}());
exports.default = AirbrakeService;
//# sourceMappingURL=airbrake.js.map